// index.js
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import ReactDOM from "react-dom/client";
import React from "react";
import App from "./App.js";
import "./index.css";
import config from "./config.js";

const msalInstance = new PublicClientApplication({
  auth: {
    clientId: "89a4862d-8568-4bc6-afee-2154d027423b", // jouw App Registration ID
    authority: "https://login.microsoftonline.com/common", // multi-tenant
    redirectUri: config.REDIRECT_URI, // moet exact kloppen
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
});

async function main() {
  await msalInstance.initialize();

  // 🔑 Probeer redirect-resultaat te verwerken (bv. na login)
  try {
    const response = await msalInstance.handleRedirectPromise();
    const account = response?.account || msalInstance.getAllAccounts()[0];

    if (account) {
      msalInstance.setActiveAccount(account);

      try {
        // Haal access_token op en zet in sessionStorage (voor tenantcontrole)
        const tokenResponse = await msalInstance.acquireTokenSilent({
          scopes: ["User.Read"],
          account: account,
        });

        sessionStorage.setItem("access_token", tokenResponse.accessToken);
      } catch (err) {
        console.warn("⚠️ Token ophalen mislukt (wordt later opnieuw geprobeerd):", err);
      }
    }
  } catch (err) {
    console.error("❌ MSAL redirect error:", err);
  }

  // 🔑 App altijd renderen — login gebeurt pas via WelkomPagina
  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    <MsalProvider instance={msalInstance}>
      <App />
    </MsalProvider>
  );
}

main();
